export default __webpack_public_path__ + "static/media/SWT1180.34I-43188_-25818_0.4114ed83.jpg";